/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHourglassTopIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hourglass-top"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.75 20.15L16.25 20.15L16.25 17.1Q16.25 15.4 14.99 14.28Q13.72 13.15 12 13.15Q10.28 13.15 9.01 14.28Q7.75 15.4 7.75 17.1ZM4.53 22.8Q3.98 22.8 3.59 22.41Q3.2 22.02 3.2 21.48Q3.2 20.93 3.59 20.54Q3.98 20.15 4.53 20.15L5.1 20.15L5.1 17.1Q5.1 15.65 5.67 14.34Q6.25 13.03 7.3 12Q6.25 10.97 5.67 9.66Q5.1 8.35 5.1 6.9L5.1 3.85L4.53 3.85Q3.98 3.85 3.59 3.46Q3.2 3.08 3.2 2.52Q3.2 1.98 3.59 1.59Q3.98 1.2 4.53 1.2L19.48 1.2Q20.02 1.2 20.41 1.59Q20.8 1.98 20.8 2.52Q20.8 3.08 20.41 3.46Q20.02 3.85 19.48 3.85L18.9 3.85L18.9 6.9Q18.9 8.35 18.32 9.66Q17.75 10.97 16.7 12Q17.75 13.03 18.32 14.34Q18.9 15.65 18.9 17.1L18.9 20.15L19.48 20.15Q20.02 20.15 20.41 20.54Q20.8 20.93 20.8 21.48Q20.8 22.02 20.41 22.41Q20.02 22.8 19.48 22.8Z" fill={color} />
    </svg>
  );
}
